import { Component, Input } from '@angular/core';
import { LegendBullet } from './models/legend-bullet.model';

@Component({
	selector: 'app-legend',
	templateUrl: './legend.component.html',
	styleUrls: ['./legend.component.scss']
})
export class LegendComponent {
	@Input() public legendBullets: LegendBullet[];
}
